
// import React, { useMemo, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import AppFooter from "../AppFooter";
// import { FaTimes, FaSave, FaShare, FaPlay } from "react-icons/fa";

// /* ---------- helpers ---------- */
// const isVideoUrl = (url = "") => /\.(mp4|webm|mov|m4v|ogg)$/i.test(url);
// const ensureArray = (v) => (Array.isArray(v) ? v : v == null ? [] : [v]);
// const splitCSV = (v) =>
//   Array.isArray(v) ? v : v ? String(v).split(",").map((s) => s.trim()).filter(Boolean) : [];
// // match EventItemDetail URL building + default-image fallback
// const toAbs = (baseUrl, p) =>
//   !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith("/") ? "" : "/"}${p}`;

// /* ---------- component ---------- */
// const Raffle = () => {
//   const { tenant, eventId, itemId } = useParams();
//   const nav = useNavigate();
//   const { state } = useLocation() || {};

//   const baseUrl =
//     process.env.REACT_APP_BASE_URL ||
//     (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");

//   // incoming context from EventItemDetail (state may be missing or partially shaped)
//   const name = state?.name || "";
//   const description = state?.description || "";
//   const type = state?.type || "default";

//   // Normalize sizes: accept arrays OR CSV strings
//   const topSizes = splitCSV(state?.topSize);
//   const bottomSizes = splitCSV(state?.bottomSize);
//   const shoeSizes = splitCSV(state?.shoeSize);

//   // Aggregate unique sizes for dropdown
//   const sizeOptions = useMemo(
//     () => Array.from(new Set([...topSizes, ...bottomSizes, ...shoeSizes])),
//     [topSizes, bottomSizes, shoeSizes]
//   );

//   // Normalize media: accept array/object/string → [{url,isVideo}]
//   const normalizedMedia = ensureArray(state?.media).map((m) => {
//     if (typeof m === "string") return { url: m, isVideo: isVideoUrl(m) };
//     if (m && typeof m === "object") return { url: m.url || "", isVideo: !!m.isVideo };
//     return { url: "", isVideo: false };
//   });

//   // selectable media tiles (we’ll render them in the same full-bleed feed style as EventItemDetail)
//   const [selectedMedia, setSelectedMedia] = useState(() =>
//     (normalizedMedia || []).map((m, i) => ({ ...m, id: i, selected: true }))
//   );
//   const toggleMedia = (id) =>
//     setSelectedMedia((cur) => cur.map((m) => (m.id === id ? { ...m, selected: !m.selected } : m)));

//   // raffle link + submitting
//   const [raffleUrl, setRaffleUrl] = useState("");
//   const [submitting, setSubmitting] = useState(false);

//   // run controls + results
//   const [qty, setQty] = useState(1);
//   const [sizeFilter, setSizeFilter] = useState("");
//   const [winners, setWinners] = useState([]);

//   // attributes preview list (unchanged behavior; just using normalized arrays)
//   const attrs = useMemo(() => {
//     const out = [];
//     if (type) out.push({ k: "type", v: type });
//     if (topSizes.length) out.push({ k: "topSize", v: topSizes });
//     if (bottomSizes.length) out.push({ k: "bottomSize", v: bottomSizes });
//     if (shoeSizes.length) out.push({ k: "shoeSize", v: shoeSizes });
//     return out;
//   }, [type, topSizes, bottomSizes, shoeSizes]);

//   const handleCancel = () => nav(`/${tenant}/${eventId}/${itemId}/eventItemDetail`);

//   const handlePost = () => {
//     const image = selectedMedia.find((m) => !m.isVideo)?.url || selectedMedia[0]?.url || "";
//     nav(`/${tenant}/${eventId}/${itemId}/mediaPost`, {
//       state: {
//         context: "raffle",
//         tenant,
//         eventId,
//         itemId,
//         title: name,
//         description,
//         image,
//         images: selectedMedia.filter((m) => !m.isVideo && m.selected).map((m) => m.url),
//         videos: selectedMedia.filter((m) => m.isVideo && m.selected).map((m) => m.url),
//       },
//     });
//   };

//   // Create raffle instance (persist) and build EventAction URL
//   const handleSubmit = async () => {
//     try {
//       setSubmitting(true);
//       const payload = {
//         name,
//         description,
//         attributes: { type, topSize: topSizes, bottomSize: bottomSizes, shoeSize: shoeSizes },
//         media: selectedMedia.filter((m) => m.selected),
//       };
//       const r = await axios.post(
//         `${baseUrl}/api/raffle/${tenant}/events/${eventId}/items/${itemId}`,
//         payload
//       );
//       const slug = r.data?.slug || r.data?.raffleId || Date.now();
//       const url = `${baseUrl}/${tenant}/${eventId}/${itemId}/eventaction?raffle=${slug}`;
//       setRaffleUrl(url);
//     } catch (e) {
//       console.error("Raffle create failed", e);
//       alert("Failed to create raffle.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // Run the raffle draw. Tries /api/raffle/.../run; falls back to /raffle-draw
//   const handleRun = async () => {
//     try {
//       if (!raffleUrl) {
//         // allow running without prior submit by calling the draw endpoint directly
//         const { data } = await axios.post(
//           `${baseUrl}/api/events/${eventId}/items/${itemId}/raffle-draw`,
//           { tenantid: tenant, qty: Number(qty) || 1, filters: sizeFilter ? { size: sizeFilter } : {} }
//         );
//         setWinners(Array.isArray(data?.winners) ? data.winners : []);
//         return;
//       }
//       // primary: run a persisted raffle instance
//       await axios.post(
//         `${baseUrl}/api/raffle/${tenant}/events/${eventId}/items/${itemId}/run`,
//         { qty: Number(qty) || 1, filters: sizeFilter ? { size: sizeFilter } : {} }
//       );
//       alert("Raffle run requested.");
//     } catch (e) {
//       console.error("Raffle run failed; trying fallback", e);
//       try {
//         const { data } = await axios.post(
//           `${baseUrl}/api/events/${eventId}/items/${itemId}/raffle-draw`,
//           { tenantid: tenant, qty: Number(qty) || 1, filters: sizeFilter ? { size: sizeFilter } : {} }
//         );
//         setWinners(Array.isArray(data?.winners) ? data.winners : []);
//       } catch (e2) {
//         console.error("Fallback raffle-draw failed", e2);
//         alert("Failed to run raffle.");
//       }
//     }
//   };

//   return (
//     <div className="container">
//       <h2 className="hdr hdr--primary hdr--lg">Raffle</h2>

//       {/* Raffle link visible with copy (like your link blocks elsewhere) */}
//       {raffleUrl && (
//         <div className="rounded p-2 mb-3" style={{ background: "#1f2937", color: "#fff" }}>
//           <div className="flex items-center justify-between gap-2">
//             <span className="truncate">{raffleUrl}</span>
//             <button
//               type="button"
//               className="btn btn-sm"
//               onClick={() => navigator.clipboard?.writeText?.(raffleUrl)}
//             >
//               Copy Link
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Form wrapper (like EventItemDetail) */}
//       <form
//         onSubmit={(e) => {
//           e.preventDefault();
//           handleSubmit();
//         }}
//       >
//         {/* Title + description, like EventItemDetail (read-only here) */}
//         <div className="form-group">
//           <label htmlFor="raffle-name">Name</label>
//           <input
//             id="raffle-name"
//             className="form-control"
//             value={name}
//             readOnly
//             placeholder="Item name"
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="raffle-desc">Description</label>
//           <textarea
//             id="raffle-desc"
//             className="form-control"
//             value={description}
//             readOnly
//             placeholder="Item description"
//           />
//         </div>

//         {/* Attributes block (mirrors EventItemDetail look/feel) */}
//         <div className="mb-3">
//           <div className="font-semibold">Attributes</div>
//           <div className="grid md:grid-cols-3 gap-2">
//             <div>
//               <label className="block text-sm mb-1">Type</label>
//               <input className="form-control" value={type} readOnly />
//             </div>
//             <div>
//               <label className="block text-sm mb-1">Top Sizes</label>
//               <input className="form-control" value={topSizes.join(", ")} readOnly />
//             </div>
//             <div>
//               <label className="block text-sm mb-1">Pant Sizes</label>
//               <input className="form-control" value={bottomSizes.join(", ")} readOnly />
//             </div>
//             <div>
//               <label className="block text-sm mb-1">Shoe Sizes</label>
//               <input className="form-control" value={shoeSizes.join(", ")} readOnly />
//             </div>
//           </div>
//         </div>

//         {/* MEDIA — full-bleed feed like EventItemDetail, with selection overlay preserved */}
//         <div className="mb-2 font-semibold">Select Media</div>
//         {selectedMedia.length ? (
//           <div className="feed" style={{ padding: 0 }}>
//             {selectedMedia.map((m) => (
//               <article key={m.id} className="feed-card" style={{ padding: 0, position: "relative" }}>
//                 <label className="absolute top-2 left-2 z-10 bg-black/60 text-white px-2 py-1 rounded">
//                   <input
//                     type="checkbox"
//                     checked={m.selected}
//                     onChange={() => toggleMedia(m.id)}
//                     style={{ marginRight: 6 }}
//                   />
//                   Select
//                 </label>
//                 {m.isVideo ? (
//                   <video
//                     className="feed-media"
//                     src={m.url}
//                     controls
//                     preload="metadata"
//                     playsInline
//                     style={{ objectFit: "contain", background: "#000" }}
//                   />
//                 ) : (
//                   <img
//                     className="feed-media"
//                     src={m.url}
//                     alt=""
//                     style={{ objectFit: "contain", background: "#000" }}
//                     onError={(e) =>
//                       (e.currentTarget.src = toAbs(baseUrl, "/public/app/default-image.png"))
//                     }
//                   />
//                 )}
//               </article>
//             ))}
//           </div>
//         ) : (
//           <p>No media passed from the item.</p>
//         )}

//         {/* Run controls (inside the same form for consistent look) */}
//         <div className="card p-4 space-y-3 rounded shadow mt-4">
//           <h3 className="font-semibold">🎟 Run Raffle</h3>

//           <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
//             <div>
//               <label className="block text-sm mb-1"># of winners</label>
//               <input
//                 type="number"
//                 min="1"
//                 value={qty}
//                 onChange={(e) => setQty(e.target.value)}
//                 className="form-control"
//                 placeholder="How many winners?"
//               />
//             </div>

//             <div className="sm:col-span-2">
//               <label className="block text-sm mb-1">Select a Size</label>
//               <select
//                 className="form-control"
//                 value={sizeFilter}
//                 onChange={(e) => setSizeFilter(e.target.value)}
//               >
//                 <option value="">All sizes</option>
//                 {sizeOptions.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//               {/* Keep text input available as well, in case sizeOptions is empty */}
//               {!sizeOptions.length && (
//                 <input
//                   type="text"
//                   value={sizeFilter}
//                   onChange={(e) => setSizeFilter(e.target.value)}
//                   className="form-control mt-2"
//                   placeholder="e.g. M, 32, 10, etc."
//                 />
//               )}
//             </div>
//           </div>

//           {winners.length > 0 && (
//             <div className="mt-2">
//               <h4 className="font-semibold">🏆 Winners</h4>
//               <ul className="list-disc pl-5">
//                 {winners.map((w) => (
//                   <li key={w.id || `${w.email}-${w.firstname}-${w.lastname}`}>
//                     {w.firstname} {w.lastname} {w.email ? `(${w.email})` : ""}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </div>

//         {/* Keep the “Submit” inside the form for keyboard enter support */}
//         <div style={{ height: 0, overflow: "hidden" }}>
//           <button type="submit">hidden submit</button>
//         </div>
//       </form>

//       <AppFooter
//         buttons={[
//           { icon: <FaTimes />, label: "Cancel", onClick: handleCancel },
//           {
//             icon: <FaSave />,
//             label: submitting ? "Submitting..." : "Submit",
//             onClick: handleSubmit,
//             disabled: submitting,
//           },
//           { icon: <FaShare />, label: "Post", onClick: handlePost },
//           { icon: <FaPlay />, label: "Run", onClick: handleRun },
//         ]}
//       />
//     </div>
//   );
// };

// export default Raffle;


// client/src/components/Raffle.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import './Raffle.css';

const Raffle = () => {
  const { tenantId, eventId, itemId } = useParams();
  const baseUrl = process.env.REACT_APP_API_URL || '';

  const [raffleData, setRaffleData] = useState(null);
  const [winners, setWinners] = useState([]);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [drawing, setDrawing] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  useEffect(() => {
    loadRaffleData();
  }, [tenantId, eventId, itemId]);

  const loadRaffleData = async () => {
    setLoading(true);
    try {
      // Get raffle config
      const configResponse = await axios.get(
        `${baseUrl}/api/raffle/${tenantId}/event/${eventId}/item/${itemId}`,
        { withCredentials: true }
      );

      if (configResponse.data.success && configResponse.data.raffle) {
        setRaffleData(configResponse.data.raffle);
      }

      // Get entries
      const entriesResponse = await axios.get(
        `${baseUrl}/api/raffle/${tenantId}/event/${eventId}/item/${itemId}/entries`,
        { withCredentials: true }
      );

      if (entriesResponse.data.success) {
        setEntries(entriesResponse.data.entries || []);
      }

      // Get winners if raffle is complete
      const winnersResponse = await axios.get(
        `${baseUrl}/api/raffle/${tenantId}/event/${eventId}/item/${itemId}/winners`,
        { withCredentials: true }
      );

      if (winnersResponse.data.success) {
        setWinners(winnersResponse.data.winners || []);
      }
    } catch (error) {
      console.error('Error loading raffle data:', error);
      setMessage({ 
        text: error.response?.data?.message || 'Error loading raffle data', 
        type: 'error' 
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRunRaffle = async () => {
    if (!raffleData) {
      setMessage({ text: 'Raffle not configured yet', type: 'error' });
      return;
    }

    const winnersPerCombo = raffleData.winners_per_combo || 1;
    
    if (!window.confirm(`Draw ${winnersPerCombo} winner(s) per attribute combination?`)) {
      return;
    }

    setDrawing(true);
    setMessage({ text: '', type: '' });

    try {
      const response = await axios.post(
        `${baseUrl}/api/raffle/${tenantId}/event/${eventId}/item/${itemId}/draw`,
        { winnersPerCombo },
        { withCredentials: true }
      );

      if (response.data.success) {
        setMessage({ 
          text: `Successfully drew ${response.data.winners.length} winner(s)!`, 
          type: 'success' 
        });
        
        // Reload data to show winners
        await loadRaffleData();
      } else {
        setMessage({ 
          text: response.data.message || 'Failed to draw winners', 
          type: 'error' 
        });
      }
    } catch (error) {
      console.error('Error running raffle:', error);
      setMessage({ 
        text: error.response?.data?.message || 'Error running raffle', 
        type: 'error' 
      });
    } finally {
      setDrawing(false);
    }
  };

  const formatAttributes = (attrs) => {
    if (!attrs || typeof attrs !== 'object') return 'N/A';
    return Object.entries(attrs)
      .map(([key, value]) => `${key.replace(/_/g, ' ')}: ${value}`)
      .join(', ');
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'NEW': { label: 'Not Started', class: 'status-new' },
      'ACTIVE': { label: 'Active', class: 'status-active' },
      'COMPLETE': { label: 'Complete', class: 'status-complete' },
      'PROCESSING': { label: 'Processing...', class: 'status-processing' }
    };

    const statusInfo = statusMap[status] || { label: status, class: 'status-default' };
    return <span className={`status-badge ${statusInfo.class}`}>{statusInfo.label}</span>;
  };

  if (loading) {
    return (
      <div className="raffle-container">
        <div className="loading-message">Loading raffle data...</div>
      </div>
    );
  }

  if (!raffleData) {
    return (
      <div className="raffle-container">
        <div className="warning-message">
          <p>No raffle configuration found for this item.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="raffle-container">
      <div className="raffle-header">
        <h2>{raffleData.name || 'Raffle'}</h2>
        {getStatusBadge(raffleData.status)}
      </div>

      {message.text && (
        <div className={`message ${message.type}`}>
          {message.text}
        </div>
      )}

      <div className="raffle-info-grid">
        <div className="info-card">
          <h3>Configuration</h3>
          <div className="info-item">
            <span className="label">Winners per combo:</span>
            <span className="value">{raffleData.winners_per_combo}</span>
          </div>
          {raffleData.size_filter && (
            <div className="info-item">
              <span className="label">Size Filter:</span>
              <span className="value">{raffleData.size_filter}</span>
            </div>
          )}
          {raffleData.start_at && (
            <div className="info-item">
              <span className="label">Start:</span>
              <span className="value">{new Date(raffleData.start_at).toLocaleString()}</span>
            </div>
          )}
          {raffleData.end_at && (
            <div className="info-item">
              <span className="label">End:</span>
              <span className="value">{new Date(raffleData.end_at).toLocaleString()}</span>
            </div>
          )}
        </div>

        <div className="info-card">
          <h3>Statistics</h3>
          <div className="info-item">
            <span className="label">Total Entries:</span>
            <span className="value">{entries.length}</span>
          </div>
          <div className="info-item">
            <span className="label">Winners Selected:</span>
            <span className="value">{winners.length}</span>
          </div>
        </div>
      </div>

      {/* Draw Button */}
      {raffleData.status !== 'COMPLETE' && raffleData.status !== 'PROCESSING' && entries.length > 0 && (
        <div className="action-section">
          <button
            onClick={handleRunRaffle}
            disabled={drawing}
            className="btn btn-primary btn-large"
          >
            {drawing ? (
              <>
                <span className="spinner"></span> Drawing Winners...
              </>
            ) : (
              'Run Raffle'
            )}
          </button>
        </div>
      )}

      {raffleData.status === 'PROCESSING' && (
        <div className="info-message">
          <p>Raffle is currently being processed. Please wait...</p>
        </div>
      )}

      {raffleData.status === 'COMPLETE' && (
        <div className="complete-message">
          <p>✓ This raffle has been completed. Winners have been notified.</p>
        </div>
      )}

      {entries.length === 0 && (
        <div className="warning-message">
          <p>No entries yet. Share the raffle entry link to collect entries.</p>
        </div>
      )}

      {/* Winners Section */}
      {winners.length > 0 && (
        <div className="winners-section">
          <h3>🎉 Winners</h3>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Attributes</th>
                  <th>Selected On</th>
                </tr>
              </thead>
              <tbody>
                {winners.map((winner) => (
                  <tr key={winner.id} className="winner-row">
                    <td><strong>{winner.name}</strong></td>
                    <td>{winner.email}</td>
                    <td>{formatAttributes(winner.attributes)}</td>
                    <td>{new Date(winner.created_on).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* All Entries Section */}
      {entries.length > 0 && (
        <div className="entries-section">
          <h3>All Entries</h3>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Attributes</th>
                  <th>Entry Date</th>
                </tr>
              </thead>
              <tbody>
                {entries.map((entry) => (
                  <tr key={entry.id}>
                    <td>{entry.name}</td>
                    <td>{entry.email}</td>
                    <td>{entry.phone || 'N/A'}</td>
                    <td>{formatAttributes(entry.attributes)}</td>
                    <td>{new Date(entry.created_on).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Raffle;